import Modal from "react-bootstrap/Modal";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useState } from "react";


function EventRecord({ values,vehiclesid,onEventSubmit,fetchevent }) {

 
  const { getDarkColor, selctedDate, show, onHide, keyss, } =
    values;
    console.log(keyss,"keyss");

    let initialState = {
      date:selctedDate,
      vehicle_id: vehiclesid?.vehicle_id,
      time: "",
      event_type_id_id : 5 ,
      address: "",
      color: getDarkColor(),
      
    
    };
  const [selected, setSelected] = useState(initialState);

console.log(vehiclesid,'iiiiiiiiiiiiiioooooo')
  const handleChange = (key, value) => {
    console.log(key, value);
    
    if (key === "title") {
      console.log("Title value:", value); // Check the value here
    }
  
    setSelected({ ...selected, [key]: value });
  };

  const handleSubmit = async (e) => {
     e.preventDefault();
     console.log(selected,'pqpqp')
      onHide();
 onEventSubmit(selected)

     fetchevent()
   
  
     
    
  };
  

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Add Event</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
              required
                label="Select Time"
                type="time"
                value={selected.time}
                onChange={(e) => handleChange("time", e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  step: 300, // 5 minutes increment
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Event</InputLabel>
                <Select
                required
                  value={selected.event_type_id}
                  
                  onChange={(e) => handleChange("event_type_id", e.target.value)}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Event"
                >

                  {keyss.map((key, index) => (
                   <MenuItem key={index} 
                   

                   value={key.id}
                   >
                  
                   <div className="d-flex align-items-center container">
                     <img
                       src={key.icon_url}
                       alt={`icon_${index}`}
                       className="img-fluid"
                       style={{ width: "30px", height: "30px" }}
                     />
                     <span>{key.request_type}</span>
                   </div>
                 </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
              required 
                id="outlined-basic"
                label="Address"
                value={selected.address}
                onChange={(e) => handleChange("address", e.target.value)}
                fullWidth
                variant="outlined"
              />
            </Grid>
           
          </Grid>
        </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
        <Grid item xs={12}>
              <Button type="submit"> Save</Button>
            </Grid>
      </Modal.Footer>
      </form>
    </Modal>
  );
}
export default EventRecord;
